import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import { scrollToTop } from "@/hooks/useScrollToTop";

interface WorkCardProps {
  work: Work;
  large?: boolean;
}

export default function WorkCard({ work, large }: WorkCardProps) {
  return (
    <Link
      to={`/work/${work.id}`}
      onClick={scrollToTop}
      data-product-shop="true"
      className="group block w-full"
    >
      <div className="relative overflow-hidden rounded-xl bg-background-800">
        <img
          src={work.cover}
          alt={`${work.title} 动态漫画封面`}
          title={`${work.title} 抖漫在线看`}
          className={`w-full object-cover object-top group-hover:scale-105 transition-transform duration-500 ${
            large ? "aspect-[3/4]" : "aspect-[3/4]"
          }`}
        />
        {/* rating badge */}
        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-1 rounded-md bg-background-950/80 backdrop-blur-sm text-accent-400 text-xs font-medium">
          <i className="ri-star-fill"></i>
          {work.rating.toFixed(1)}
        </div>
        {/* status badge */}
        <div
          className={`absolute top-2 right-2 px-2 py-1 rounded-md text-xs font-medium ${
            work.status === "已完结"
              ? "bg-secondary-500 text-background-950"
              : "bg-primary-500 text-background-950"
          }`}
        >
          {work.status}
        </div>
        {/* episode overlay */}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/90 to-transparent px-3 pb-2 pt-10">
          <div className="flex items-center justify-between text-xs text-foreground-200">
            <span className="flex items-center gap-1">
              <i className="ri-play-list-line"></i>
              {work.episodes}集
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {work.views}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="font-medium text-foreground-50 group-hover:text-primary-400 transition-colors text-sm md:text-base whitespace-nowrap overflow-hidden text-ellipsis">
          {work.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="px-2 py-0.5 rounded bg-background-800 text-primary-400 text-xs whitespace-nowrap">
            {work.categoryName}
          </span>
          <span className="text-xs text-foreground-600 whitespace-nowrap">{work.updateAt}</span>
        </div>
      </div>
    </Link>
  );
}